import React, { type InputHTMLAttributes, type ReactNode } from "react";
import { useIntl } from "react-intl";
import { Field } from "redux-form";
import type { BaseFieldProps } from "redux-form/lib/Field";
import type IFormInputs from "./IFormInputs";
import InputRenderer from "shared/forms/formrenderers/InputRenderer";

export interface ISelectInputProps
  extends IFormInputs,
    InputHTMLAttributes<HTMLSelectElement> {
  validate?: BaseFieldProps["validate"];
  children?: ReactNode;
  selectText?: string;
}

export const SelectInput = ({
  inputID,
  label = null,
  children,
  selectText,
  ...rest
}: ISelectInputProps) => {
  const { formatMessage } = useIntl();
  return (
    <Field
      name={inputID}
      label={label}
      type="select"
      component={InputRenderer}
      {...rest}
    >
      <option value="">
        {selectText ?? formatMessage({ id: "ui.select" })}
      </option>
      {children}
    </Field>
  );
};
